module.exports = __webpack_public_path__ + "static/media/messages-initial-ilustrator.847fd292.svg";